module.exports = __webpack_public_path__ + "img/3.06a65d51.png";